import { useState, useEffect, Fragment } from 'react'
import {  
  Link, NavLink, useLocation, useNavigate, Outlet
} from "react-router-dom";
import { Dialog, Disclosure, Menu, Transition } from '@headlessui/react'
import { 
    Bars3Icon, XMarkIcon, UserCircleIcon, ChevronDownIcon, BellIcon, ArrowLeftOnRectangleIcon,
} from '@heroicons/react/24/outline'
import { 
    HomeIcon, TagIcon, UsersIcon, UserIcon, UserGroupIcon, ClipboardDocumentCheckIcon,
    DocumentIcon
} from '@heroicons/react/24/solid'
import Logo from '../../images/logo.png'

const navigation = [
    { name: 'Dashboard', href: '/admin/', icon: HomeIcon },
    { name: 'Catégories', href: '/admin/categories', icon: TagIcon },
    { name: 'Produits', href: '/admin/products', icon: DocumentIcon },
    { name: 'Commandes', href: '/admin/orders', icon: ClipboardDocumentCheckIcon },
    // { name: 'Clients', href: '/admin/customers', icon : UserGroupIcon},
    // { name: 'Utilisateurs', href: '/admin/users', icon: UsersIcon },
    { name: 'Votre profil', href: '/admin/account', icon: UserIcon },
  ]

export default function SideBar() {
  const [open, setOpen] = useState(false)
  
  const handleClose = (e) => {
    e.stopPropagation(); // <-- prevent further bubbling of click event
    setOpen(false);
  };

return(
<div className="antialiased bg-gray-50">
    <nav className="bg-white border-b border-gray-200 px-4 py-2.5 fixed left-0 right-0 top-0 z-40">
      <div className="flex flex-wrap justify-between items-center">
        <div className="flex justify-start items-center">
        <button type='button' onClick={() => setOpen(true)} className="text-sm lg:hidden font-semibold leading-6 text-gray-900  px-2.5 py-2">
            <div className='flex space-x-1'>
            <Bars3Icon className="h-6 w-6 " aria-hidden="true"/>
            </div>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-50" open={open} onClose={setOpen}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="-translate-x-full"
                            enterTo="-translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="-translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <Dialog.Panel className="pointer-events-auto relative w-64 max-w-sm">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-in-out duration-500"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in-out duration-500"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="absolute right-0 top-0 -mr-8 flex pl-2 pt-4 sm:-mr-10 sm:pl-4">
                                <button
                                    type="button"
                                    className="relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                    onClick={() => setOpen(false)}
                                >
                                    <span className="absolute -inset-2.5" />
                                    <span className="sr-only">Close panel</span>
                                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                </button>
                                </div>
                            </Transition.Child>
                            <div className="flex h-full flex-col  bg-black py-6 shadow-xl">
                                <div className="px-4 sm:px-6">
                                <Dialog.Title className="text-2xl font-semibold leading-6 text-white">
                                    Rokasa Dashboard
                                </Dialog.Title>
                                </div>
                                <div className="relative mt-8 flex-1 px-4 sm:px-6">
                                {/* Your content */}
                                    <ul className="space-y-4">
                                        {navigation.map((item) => (
                                        <li>
                                            <NavLink to={item.href} onClick={handleClose}
                                              className={({ isActive }) => (isActive ? "flex items-center p-2 text-base font-medium text-gray-900 rounded-lg bg-gray-100  group" : 'flex items-center p-2 text-base font-medium text-white hover:text-gray-900 rounded-lg hover:bg-gray-100  group')}>
                                              <item.icon className="flex-shrink-0 w-6 h-6 transition duration-75 "/>
                                              <span className="ml-3">{item.name}</span>
                                            </NavLink>
                                        </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className='flex justify-center'>
                                  <ArrowLeftOnRectangleIcon className='text-white text-start w-8 h-8'/>
                                </div>
                            </div>
      
                            </Dialog.Panel>
                        </Transition.Child>
                        </div>
                    </div>
                    </div>
                </Dialog>
                </Transition.Root>
            </button>
          <a href="/" className="flex items-center justify-between mr-4">
            {/* <img src={Logo} className="mr-3 h-8" alt="Logo" /> */}
            <span className="self-center hidden lg:flex text-2xl font-semibold text-gray-900 whitespace-nowrap ">Rokasa Dashboard</span>
          </a>
        </div>

        <div className="flex items-center lg:order-2">
          
          {/* <!-- Notifications --> */}
          <button
            type="button"
            data-dropdown-toggle="notification-dropdown"
            className="p-2 mr-0 text-gray-700 rounded-lg hover:text-gray-900 hover:bg-gray-100 "
          >
            <span className="sr-only">View notifications</span>
            <BellIcon className='h-6 w-6'/>
          </button>
          
          <Menu as="div" className="relative">
                <div>
                    <span className="sr-only">Open user menu</span>
                      <Menu.Button className="inline-flex w-full justify-center rounded-md px-4 py-2 text-sm font-medium text-gray-700  focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
                        <UserCircleIcon className="h-6 w-6 mr-1.5" aria-hidden="true"/> 
                        Rosy
                        <ChevronDownIcon
                        className="-mr-1 ml-2 h-5 w-5 text-gray-700 hover:text-gray-900"
                        aria-hidden="true"/>
                    </Menu.Button>
                    </div>
                   <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95" >
                      <Menu.Items className="absolute right-0 z-10 text-start mt-2 w-36 origin-top-right rounded-md bg-white p-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item >
                            <a href='/admin/account'
                                  className='block w-full px-4 py-1 text-sm text-center leading-7 hover:bg-gray-100 text-gray-900'>
                                Votre profil
                            </a>
                        </Menu.Item>
                        <Menu.Item >
                            <a href='/Login'
                                  className='block w-full px-4 py-1 text-sm text-center leading-7 hover:bg-gray-100 text-gray-900'>
                                Se deconnecter
                            </a>
                        </Menu.Item>
                    </Menu.Items>
                  </Transition>
            </Menu>
        </div>
      </div>
    </nav>

    {/* <!-- Sidebar --> */}

    <aside className="fixed top-0 left-0 z-50 w-64 h-screen pt-4 transition-transform -translate-x-full bg-black border-r border-gray-200 md:translate-x-0 ">
    <span className="p-4 text-2xl font-semibold text-white ">Rokasa Dashboard</span>
      <div className="overflow-y-auto py-5 px-3 h-full pt-10">
        <ul className="space-y-3">
        {navigation.map((item) => (
          <li>
            <NavLink to={item.href} 
              className={({ isActive }) => (isActive ? "flex items-center p-2 text-base font-medium text-gray-900 rounded-lg bg-gray-100  group" : 'flex items-center p-2 text-base font-medium text-white hover:text-gray-900 rounded-lg hover:bg-gray-100  group')}>
              <item.icon  className="flex-shrink-0 w-6 h-6  transition duration-75  "/>
              <span className="ml-3">{item.name}</span>
            </NavLink>
          </li>
          ))}
        </ul>     
        <div className='hidden absolute bottom-0 left-0 justify-center p-4 space-x-4 w-full lg:flex bg-black z-20'>
          <ArrowLeftOnRectangleIcon className='text-white w-8 h-8'/>
        </div>
      </div>
      
    </aside>

    <div className="p-4 md:ml-64 h-full pt-20 bg-white">
        <Outlet />
    </div>
  </div>
)
}